import { Button, Card, CardBody, CardHeader, CardTitle, Col, Row } from 'reactstrap'
import ExamIllustration from '../../assets/exam-illustration.png'
import AdmitCardicon from '../../assets/admit-card-icon.png'
import ButtonText from 'components/shared/ButtonText'
import styles from './card.module.css'
import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import EditExamDetails from 'components/ExamDetailsEdit/EditExamDetails'
import { extractQueryParams } from 'utils/getAllURLParameters'

const mapStateToProps = (state) => ({
    token: state?.token,
})

function ExamCard(props) {
    const {
        cardData,
        profileData,
        staticData,
        token,
        refetchDashboard,
        fetchDashboardData,
        fetchProfileData,
    } = props
    let date=new Date();
    const [isEditExamOpen, setIsEditExamOpen] = React.useState(false)
    const examType = profileData?.exam_type || 'ANTHE';
    const handleEditExam = () => {
        setIsEditExamOpen(!isEditExamOpen)
        const eventName =
        examType === 'AKTHE'
            ? 'AKTHE_db_edit_exam_details'
            : 'ANTHE_db_edit_exam_details';
        window.webengage.track(eventName, {
            'mobile number': profileData.mobile_number,
            'roll number': profileData.roll_number,
            psid: profileData.student_psid ? profileData.student_psid : 'NA',
            'exam type': examType,
            class_studying: profileData.class.toString(),
            stream: profileData.stream,
            branchcode: profileData.exam_center_id,
            Year:date.getFullYear(),
            edit_attempts_left:
                (profileData.exam_attempts_left &&
                    profileData.exam_attempts_left.toString()) ||
                '0',
        })
    }

    const apiData = {
        token,
        test_short_code: cardData.test_short_code,
        source_type: 'aakash',
    }
    let parameters = {}
    const queryString = window.location.search
    const queryParamsArray = queryString.replace('?', '').split(/&|=/)
    parameters = extractQueryParams(queryParamsArray)
    let isPaymentParam =
        parameters.hasOwnProperty('status') && parameters.hasOwnProperty('mode')

    useEffect(() => {
        if (
            isPaymentParam &&
            parameters.editExam === 'true' &&
            parameters.status === 'failure'
        ) {
            setIsEditExamOpen(true)
        }

        // eslint-disable-next-line
    }, [isPaymentParam])

    const handleViewResultCta = () => {
        const {
            roll_number,
            class: class_studying,
            exam_type,
            stream,
            exam_center_id,
            exam_state,
        } = profileData
        const eventStudentView=
        examType === 'AKTHE'
            ? 'AKTHE_db_main_result_student_view'
            : 'ANTHE_db_main_result_student_view';
        window.webengage.track(eventStudentView, {
            'roll number': roll_number,
            exam_type:examType,
            class_studying,
            stream,
            state: exam_state,
            branchCode: exam_center_id,
            Year:date.getFullYear()
            
        })
        window.open(cardData.report_link, '_blank', 'noopener')
    }

    const finalButtonText =
        cardData?.exam_button_text?.toLowerCase() === 'start now' &&
            profileData?.resume_btn === 1
            ? 'Resume test'
            : cardData?.exam_button_text
            

    return (
        <>
            <Card className={`${styles.mainExamCard} d-xl-none`}>
                <CardHeader
                    className={`bg-primary fw-bold text-white text-center ${styles.mainExamCardHeader}`}
                >
                    {cardData.card_title}
                </CardHeader>

                <CardBody className="pb-0">
                    <Row>
                        <Col xs={8}>
                            <CardTitle tag="h5" className="text-grey-black fw-bold">
                                Hey {profileData.student_firstname}!
                            </CardTitle>
                        </Col>
                        <Col xs={4} className="text-end">
                            {cardData.is_admit_card_available && (
                                <div>
                                    <a
                                        target="_blank"
                                        without
                                        rel="noreferrer"
                                        href={cardData.admit_card_url}
                                        onClick={() => {
                                            const examType = profileData.exam_type || 'ANTHE';
                                            const eventName =
                                                examType === 'AKTHE'
                                                    ? 'AKTHE_db_download_admit_card'
                                                    : 'ANTHE_db_download_admit_card';
                                            window.webengage.track(
                                                eventName,
                                                {
                                                    'mobile number':
                                                        profileData.mobile_number,
                                                    'roll number':
                                                        profileData.roll_number,
                                                    psid: profileData.student_psid
                                                        ? profileData.student_psid
                                                        : 'NA',
                                                    'exam type':
                                                        examType,
                                                    class_studying:
                                                        profileData.class.toString(),
                                                    stream: profileData.stream,
                                                    state: profileData.exam_state,
                                                    center: profileData.exam_center,
                                                    location:
                                                        profileData.exam_location,
                                                    'exam time':
                                                        profileData.exam_mode_and_slot,
                                                    'exam date':
                                                        profileData.exam_date,
                                                    Year:date.getFullYear()
                                                },
                                            )
                                        }}
                                        className="text-aqua font-size-xs font-size-md-sm font-size-xs fw-normal text-decoration-none"
                                    >
                                        Admit card{' '}
                                        <img
                                            src={AdmitCardicon}
                                            alt="AdmitCard-download-icon"
                                            className="ms-1"
                                        />
                                    </a>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="justify-content-between mt-3">
                        <Col
                            sm={12}
                            md={7}
                            className="d-flex justify-content-center"
                        >
                            <Col>
                                <p className="font-size-xs m-0 fw-light">Date</p>
                                <p className="font-size-xs font-size-md-md fw-bold">
                                    {cardData.exam_date}
                                </p>
                            </Col>
                            <Col xs={5} style={{ whiteSpace: 'pre' }}>
                                <p className="font-size-xs m-0 fw-light">Timings</p>
                                <p className="font-size-xs font-size-md-md fw-bold">
                                    {cardData.exam_time}
                                </p>
                            </Col>
                            <Col>
                                <div className={styles.mobileExamCardDuration}>
                                    <p className="font-size-xs m-0 fw-light">
                                        Duration
                                    </p>
                                    <p className="font-size-xs font-size-md-md fw-bold">
                                        {cardData.exam_duration}
                                    </p>
                                </div>
                            </Col>
                        </Col>
                        <Col sm={12} md={4}>
                            {cardData.view_report ? (
                                <>
                                    <Button
                                        onClick={handleViewResultCta}
                                        className={`btn-aqua text-white w-100 font-size-sm fw-bold mb-1`}
                                    >
                                        {cardData.report_text}
                                    </Button>
                                    <p className="text-gray font-size-xxs lh-1">
                                        Post clicking "View Result", wait for 5
                                        seconds for result pdf generation
                                    </p>
                                </>
                            ) : (
                                <a href={cardData.exam_button_text=="Visit Branch"?"#Visit_new_branch_sec":"javascript:void(0)"}>
                                <ButtonText
                                    buttonText={finalButtonText}
                                   // actionLink={cardData.exam_button_link}
                                    cardType="mainCard"
                                    apiData={apiData}
                                    profileData={profileData}
                                />
                                </a>
                            )}
                        </Col>
                    </Row>
                    {cardData.center_address &&
                        cardData.center_address.length > 0 && (
                            <Col className="font-size-xs bg-light col p-2 m-2 mt-3 text-center">
                                Offline exam centre - {cardData.center_address}
                            </Col>
                        )}
                    <Row className="align-bottom my-2">
                        {!profileData.remove_edit_exam_edit_profile && (
                            <Col>
                                <span
                                    className="font-size-xs font-size-md-sm text-aqua text-decoration-underline cursor-pointer"
                                    onClick={handleEditExam}
                                >
                                    View/ Edit Details
                                </span>
                            </Col>
                        )}
                        <Col className="font-size-xs font-size-md-sm text-end align-self-center">
                            Need help?&nbsp;
                            <a
                                href={'tel:' + cardData.exam_help_line}
                                className={`text-aqua`}
                            >
                                <span>Call now</span>
                            </a>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <a
                href={staticData.termsLink}
                target="_blank"
                rel="noreferrer"
                className="font-size-xs text-grey d-lg-none text-decoration-none"
            >
                *Terms and Conditions Apply
            </a>

            <Card className={`${styles.mainExamCardDesktop} d-none d-xl-block`}>
                {profileData.exam_type === 'AKTHE' && (
                    <CardHeader
                        className={`bg-primary fw-bold text-white text-center ${styles.mainExamCardHeader}`}
                    >
                        {cardData.card_title}
                    </CardHeader>
                )}
                <CardBody className="pb-0 h-100">
                    <Row className="h-75 justify-content-between">
                        <Col className={`me-lg-0 ${styles.desktopTitle} me-xl-3`}>
                            <CardTitle
                                tag="h3"
                                className="text-grey-black fw-bold"
                                style={{ position: 'absolute' }}
                            >
                                Hey {profileData.student_firstname}!
                            </CardTitle>
                            <img
                                src={ExamIllustration}
                                alt="students-degree-illustration"
                                className="d-none d-md-block"
                                width={328}
                            />
                        </Col>

                        {cardData.is_admit_card_available && (
                            <Col
                                lg={3}
                                style={{ position: 'absolute', right: '50px' }}
                            >
                                <a
                                    target="_blank"
                                    without
                                    rel="noreferrer"
                                    onClick={() => {
                                            const examType = profileData.exam_type || 'ANTHE';
                                            const eventName =
                                                examType === 'AKTHE'
                                                    ? 'AKTHE_db_download_admit_card'
                                                    : 'ANTHE_db_download_admit_card';
                                        window.webengage.track(
                                            eventName,
                                            {
                                                'mobile number':
                                                    profileData.mobile_number,
                                                'roll number':
                                                    profileData.roll_number,
                                                psid: profileData.student_psid
                                                    ? profileData.student_psid
                                                    : 'NA',
                                                'exam type': examType,
                                                class_studying:
                                                    profileData.class.toString(),
                                                stream: profileData.stream,
                                                state: profileData.exam_state,
                                                center: profileData.exam_center,
                                                location: profileData.exam_location,
                                                'exam time':
                                                    profileData.exam_mode_and_slot,
                                                'exam date': profileData.exam_date,
                                                Year:date.getFullYear()
                                            },
                                        )
                                        examType==='AKTHE'??
                                           window.webengage.track(
                                            eventName,
                                            {
                                                'mobile number':
                                                    profileData.mobile_number,
                                                'roll number':
                                                    profileData.roll_number,
                                                psid: profileData.student_psid
                                                    ? profileData.student_psid
                                                    : 'NA',
                                                'exam type': examType,
                                                class_studying:
                                                    profileData.class.toString(),
                                                stream: profileData.stream,
                                                state: profileData.exam_state,
                                                center: profileData.exam_center,
                                                location: profileData.exam_location,
                                                'exam time':
                                                    profileData.exam_mode_and_slot,
                                                'exam date': profileData.exam_date,
                                                Year:date.getFullYear()
                                            },
                                        )  
                                    }}
                                    href={cardData.admit_card_url}
                                    className="text-blue  font-size-md text-decoration-none font-size-xs fw-normal mt-3 mb-2"
                                >
                                    Admit card{' '}
                                    <img
                                        src={AdmitCardicon}
                                        alt="AdmitCard-download-icon"
                                        className="ms-1"
                                    />
                                </a>
                            </Col>
                        )}

                        <Col className="align-self-center me-xl-3 mt-4">
                            <Row className="d-flex justify-content-between align-items-center">
                                <Col xs={4}>
                                    <p
                                        className={`font-size-md m-0 fw-light ${
                                            profileData.remove_edit_exam_edit_profile
                                                ? 'lh-1'
                                                : ''
                                        }`}
                                    >
                                        Date
                                    </p>
                                    <p
                                        className={`font-size-md fw-bold ${
                                            !profileData.remove_edit_exam_edit_profile
                                                ? 'mb-0 lh-1'
                                                : ''
                                        }`}
                                        style={{ whiteSpace: 'pre' }}
                                    >
                                        {cardData.exam_date}
                                    </p>
                                    {!profileData.remove_edit_exam_edit_profile && (
                                        <span
                                            className={`font-size-xs text-aqua text-decoration-underline cursor-pointer`}
                                            onClick={handleEditExam}
                                        >
                                            View/ Edit Details
                                        </span>
                                    )}
                                </Col>
                                <Col xs={6} xl={4} className="ms-md-2 ms-xl-0">
                                    <p className="font-size-md m-0 fw-light lh-1">
                                        Timings
                                    </p>
                                    <p
                                        className="font-size-md fw-bold"
                                        style={{ whiteSpace: 'pre' }}
                                    >
                                        {cardData.exam_time}
                                    </p>
                                </Col>
                                <Col xl={2} className="ms-4 text-end">
                                    <p className="font-size-md m-0 fw-light lh-1">
                                        Duration
                                    </p>
                                    <p className="font-size-md fw-bold">
                                        {cardData.exam_duration}
                                    </p>
                                </Col>
                            </Row>
                            {cardData.center_address &&
                                cardData.center_address.length > 0 && (
                                    <Row
                                        style={{
                                            position: 'relative',
                                            bottom: '0.2rem',
                                        }}
                                    >
                                        <Col className="font-size-xs bg-light col p-2 m-2 mt-3 text-center">
                                            Offline exam centre -{' '}
                                            {cardData.center_address}
                                        </Col>
                                    </Row>
                                )}
                        </Col>
                        <Col
                            md={3}
                            className="h-100 d-flex flex-column justify-content-between"
                        >
                            <div className="font-size-sm text-end d-flex justify-content-end">
                                Need help?&nbsp;
                                <a
                                    onClick={() => {
                                    const examType = profileData?.exam_type || 'ANTHE';
                                    const eventName =
                                        examType === 'AKTHE'
                                            ? 'AKTHE_db_call_now'
                                            : 'ANTHE_db_call_now';
                                        window.webengage.track(eventName, {
                                            'support number':
                                                cardData.exam_help_line,
                                            'exam type': profileData.exam_type,
                                            center: profileData.center_name,
                                            class:
                                                profileData.class &&
                                                profileData.class.toString(),
                                            stream: profileData.stream,
                                            Year:date.getFullYear()
                                        })
                                    }}
                                    href={'tel:' + cardData.exam_help_line}
                                    className={`font-size-xs text-aqua`}
                                >
                                    <span className="d-xl-none p-auto">
                                        Call now
                                    </span>
                                </a>
                                <span className="d-none d-xl-block font-size-sm text-black">
                                    Call us at&nbsp;
                                </span>
                                <span className="d-none d-xl-block font-size-sm fw-lighter text-black">
                                    {cardData.exam_help_line}
                                </span>
                            </div>
                            <div className="mt-4">
                                {cardData.view_report ? (
                                    <>
                                        <Button
                                            onClick={handleViewResultCta}
                                            className={`btn-aqua text-white w-100 font-size-sm fw-bold`}
                                        >
                                            {cardData.report_text}
                                        </Button>
                                        <p className=" font-size-xxs m-0">
                                            Post clicking "View Result", wait for 5
                                            seconds for result pdf generation
                                        </p>
                                    </>
                                ) : (
                                    <a href={cardData.exam_button_text=="Visit Branch"?"#Visit_new_branch_sec":"javascript:void(0)"}>
                                    <ButtonText
                                        buttonText={finalButtonText}
                                       // actionLink={cardData.exam_button_link}
                                        cardType="mainCard"
                                        apiData={apiData}
                                        profileData={profileData}
                                    />
                                    </a>
                                )}
                            </div>
                            <p className="text-end mb-0">
                                <a
                                    href={staticData.termsLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="font-size-xs text-grey mt-2 text-decoration-none"
                                >
                                    *Terms and Conditions Apply
                                </a>
                            </p>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {isEditExamOpen && (
                <EditExamDetails
                    fetchDashboardData={fetchDashboardData}
                    fetchProfileData={fetchProfileData}
                    modal={isEditExamOpen}
                    toggle={handleEditExam}
                    refetchDashboard={refetchDashboard}
                />
            )}
        </>
    )
}

export default connect(mapStateToProps)(ExamCard)
